(function () {
    'use strict';

    var $               = require('jquery');
    var $button         = $('.contact-button');
    var $contactBlock   = $('.contact-form-wrapper');

    if (
        $button.length > 0 &&
        $contactBlock.length > 0
    ) {

        var buttonTop       = $button.offset().top;
        var contactBlockTop = $contactBlock.offset().top;

        $(window).on('load scroll touchmove', function () {

            var scrollTop = $(this).scrollTop();

            if (buttonTop > (contactBlockTop - scrollTop)) {
                $button.addClass('fade');
            } else {
                $button.removeClass('fade');
            }

        });

    }

})();